import{o}from"./ownerDocument-1b00e83d.js";function e(e){return o(e).defaultView||window}export{e as o};
